import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../../lib/shared/validators";

export const validatorCorrelative = v.object({
  name: v.string(),
  branchId: v.optional(v.id("branches")),
  branchCode: v.string(),
  nextCorrelative: v.number(), // Siguiente número correlativo
  rangeStart: v.number(), // Inicio del rango autorizado (opcional)
  rangeEnd: v.number(), // Fin del rango autorizado (opcional)
  printingAuthorizationCode: v.string(), // CAI asignado por el SAR (alfanumérico)
  expirationDate: v.number(), // Fecha de vencimiento de la autorización
  // Ultima vez que se notifico al usuario que este correlativo esta expirado.
  // Permite que `checkAndNotify` sea idempotente y no spamee notificaciones.
  expirationNotifiedAt: v.optional(v.number()),
  emissionPointId: v.id("emission_points"),
  emissionPointCode: v.string(),
  documentTypeId: v.id("documents_types"),
  internalControl,
  isDefault: v.boolean(),
});

export const correlatives = defineTable(validatorCorrelative)
  .index("by_company_id", ["internalControl.companyId"])
  .index("printingAuthorizationCode", ["printingAuthorizationCode"])
  .index("documentTypeId", ["documentTypeId"])
  .index("by_branch_id", ["internalControl.branchId"])
  .index("by_state", ["internalControl.state"])
  .index("by_company_and_state", [
    "internalControl.companyId",
    "internalControl.state",
  ])
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ])
  .index("by_branch_and_state", [
    "internalControl.branchId",
    "internalControl.state",
  ])
  .index("by_created_by", ["internalControl.createdBy"])
  .index("by_updated_by", ["internalControl.updatedBy"])
  .index("by_created_at", ["internalControl.createdAt"])
  .index("by_company_and_created_at", [
    "internalControl.companyId",
    "internalControl.createdAt",
  ]);
